import { Link } from 'react-router-dom';
import { latestUpdates, manhwaComics } from '@/mocks/manhwa';

export default function LatestUpdates() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="lg:w-7/12">
            <span className="text-xs font-medium text-primary-500 tracking-wider uppercase">Latest Updates</span>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight mt-3">
              最新更新
              <br />
              实时追踪韩漫动态
            </h2>
            <p className="text-sm text-foreground-500 mt-4 max-w-md leading-relaxed">
              每天更新的漫画章节，让你不错过任何精彩内容。追更党必备，随时了解你喜爱漫画的最新进展。
            </p>
            <div className="flex items-center gap-4 mt-8">
              <Link
                to="/category/fantasy-adventure"
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                立即追更
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-all duration-200 whitespace-nowrap"
              >
                查看更多
              </Link>
            </div>
          </div>

          {/* Right - Latest Updates List */}
          <div className="lg:w-5/12">
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/60">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900">最近更新</h3>
                <span className="text-xs text-primary-500">实时</span>
              </div>
              <div className="space-y-1">
                {latestUpdates.map((update) => {
                  const comic = manhwaComics.find(m => m.id === update.comicId);
                  return (
                    <Link
                      key={update.id}
                      to={comic ? `/article/${comic.slug}` : '#'}
                      className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-50 transition-colors group"
                    >
                      <div className="w-10 h-14 rounded overflow-hidden bg-background-200 shrink-0">
                        <img
                          src={update.coverImage}
                          alt={update.chapterTitle}
                          className="w-full h-full object-cover object-top"
                          loading="lazy"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                          {comic?.title || '未知漫画'}
                        </p>
                        <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{update.chapterTitle}</p>
                      </div>
                      <span className="text-xs text-foreground-400 whitespace-nowrap shrink-0">{update.updateTime}</span>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}